export const MOBILE_TAB_LINKS = {
  queue: '/queue',
  completedEvents: '/inspections/completed',
};

export const MOBILE_TAB_LABELS: Record<string, string> = {
  [MOBILE_TAB_LINKS.completedEvents]: 'ServicingService::Menu:Events',
};

export enum MobileMenuTranslate {
  SettingsTitle = 'mobileMenu.settings.title',
}

export type MobileMenuTranslateValues = {
  [key in MobileMenuTranslate]: string;
};

export const MobileMenuTranslateDefaults: MobileMenuTranslateValues = {
  [MobileMenuTranslate.SettingsTitle]: 'Settings',
};
